// Zorg Vleugel Branding Components

// Logo Component
export const ZorgVleugelLogo = ({ className = "w-8 h-8" }) => (
  <img 
    src="https://customer-assets.emergentagent.com/job_caregiver-hub-25/artifacts/7i9n9nvr_Zorg%20Vleugel%20Logo%20Icoon%20Rood.png" 
    alt="Zorg Vleugel" 
    className={`${className} object-contain`}
  />
);

// AI Mascot Component
export const AdelaarMascot = ({ className = "w-10 h-10", animated = false }) => (
  <div className={`${className} relative flex items-center justify-center`}>
    <img 
      src="https://customer-assets.emergentagent.com/job_caregiver-hub-25/artifacts/7i9n9nvr_Zorg%20Vleugel%20Logo%20Icoon%20Rood.png" 
      alt="Adelaar AI" 
      className="w-full h-full object-contain"
    />
    {animated && (
      <span className="absolute -bottom-1 -right-1 w-3 h-3 bg-green-400 rounded-full border-2 border-white animate-pulse" />
    )}
  </div>
);

// Quick Reply Button Component
export const QuickReplyButton = ({ text, icon, onClick, variant = 'default' }) => (
  <button
    onClick={() => onClick(text)}
    className={`
      inline-flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium
      transition-all duration-200 transform hover:scale-105
      ${variant === 'primary' 
        ? 'bg-gradient-to-r from-[#1e3a5f] to-[#2d5a87] text-white shadow-md hover:shadow-lg' 
        : variant === 'danger'
        ? 'bg-red-500 text-white shadow-md hover:bg-red-600'
        : 'bg-white border border-slate-200 text-slate-700 hover:bg-slate-50 hover:border-[#d4a853] shadow-sm'
      }
    `}
    data-testid={`quick-reply-${text.toLowerCase().replace(/\s+/g, '-')}`}
  >
    {icon && <span>{icon}</span>}
    <span>{text}</span>
  </button>
);
